/**
 * DAAM business contact placeholders.
 *
 * IMPORTANT: These are placeholder values. Real company registration
 * number, VAT number, physical address, and phone must be reviewed and
 * supplied by the business owner before public launch. The `.env` file
 * doesn't expose these to the frontend by default, so we centralise
 * them here and read from `REACT_APP_BUSINESS_*` when available. Any
 * value missing from env falls back to the string below and displays
 * a small "placeholder" hint next to it in legal pages.
 */
const env = (k, fallback) => (process.env[k] && String(process.env[k]).trim()) || fallback;

export const BUSINESS = {
  legal_name:   env("REACT_APP_BUSINESS_LEGAL_NAME",  "DAAM (getdaam.com)"),
  trade_name:   env("REACT_APP_BUSINESS_TRADE_NAME",  "DAAM"),
  cr_number:    env("REACT_APP_BUSINESS_CR_NUMBER",   "—"), // KSA Commercial Registration
  vat_number:   env("REACT_APP_BUSINESS_VAT_NUMBER",  "—"), // 15-digit TRN
  address:      env("REACT_APP_BUSINESS_ADDRESS",     "Riyadh, Kingdom of Saudi Arabia"),
  address_ar:   env("REACT_APP_BUSINESS_ADDRESS_AR",  "الرياض، المملكة العربية السعودية"),
  email_support:env("REACT_APP_BUSINESS_SUPPORT_EMAIL", "support@getdaam.com"),
  email_legal:  env("REACT_APP_BUSINESS_LEGAL_EMAIL",   "legal@getdaam.com"),
  // Public contact number — displayed with Arabic-Indic numerals on the
  // AR footer and Western digits on the EN footer. The href variant is
  // the E.164 form that mobile dialers understand.
  phone_display: env("REACT_APP_BUSINESS_PHONE_DISPLAY", "+966 55 837 1371"),
  phone_href:    env("REACT_APP_BUSINESS_PHONE_HREF",    "+966558371371"),
  // Legacy keys kept so stale callers don't crash; prefer `phone_display`.
  phone:        env("REACT_APP_BUSINESS_PHONE",        "+966 55 837 1371"),
  response_sla_hours: Number(env("REACT_APP_BUSINESS_RESPONSE_SLA_HOURS", "48")),
};

// Fields the owner MUST review before commercial launch. Consumed by
// legal pages to show a small "requires owner review" note when the
// placeholder is still in place.
export const PLACEHOLDER_FIELDS = new Set([
  "cr_number", "vat_number",
]);

export function isPlaceholder(field) {
  const v = BUSINESS[field];
  if (!v) return true;
  if (v === "—") return true;
  return false;
}
